import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "app-otp-field" }
const _hoisted_2 = {
  key: 0,
  class: "field-label"
}
const _hoisted_3 = {
  key: 1,
  class: "field-error"
}

import { computed, useAttrs } from "vue";


export default /*@__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'AppOTPField',
  props: /*@__PURE__*/_mergeModels({
    variant: { default: "outlined" },
    label: { default: "" },
    labelIcon: { default: "" },
    length: { default: 6 },
    divider: { default: "" },
    placeholder: { default: "" },
    masked: { type: Boolean, default: false },
    focusAll: { type: Boolean, default: false },
    errorMessage: { default: "" }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {



const model = _useModel<string | number | undefined>(__props, "modelValue");

const props = __props;

const attrs = useAttrs();
const fieldClass = computed(() => ["app-otp-field__input", attrs.class]);

const fieldAttrs = computed(() => {
  const { class: _class, ...rest } = attrs;
  return rest;
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_otp_input = _resolveComponent("v-otp-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (__props.labelIcon)
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 0,
                size: "18"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.labelIcon), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("span", null, _toDisplayString(__props.label), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_otp_input, _mergeProps({
      modelValue: model.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
      class: fieldClass.value,
      variant: __props.variant,
      length: __props.length,
      type: "number",
      divider: __props.divider,
      placeholder: __props.placeholder,
      masked: __props.masked,
      "focus-all": __props.focusAll,
      error: Boolean(__props.errorMessage)
    }, fieldAttrs.value), null, 16, ["modelValue", "class", "variant", "length", "divider", "placeholder", "masked", "focus-all", "error"]),
    (__props.errorMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.errorMessage), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})